import { render } from "./CollapseItem.vue?vue&type=template&id=3ffb45e6&scoped=true"
import script from "./CollapseItem.vue?vue&type=script&lang=js"
export * from "./CollapseItem.vue?vue&type=script&lang=js"

import "./CollapseItem.vue?vue&type=style&index=0&id=3ffb45e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffb45e6"]])

export default __exports__